<template>
    <div id="reporting">

      <div class="content-wrapper">
            <div class="page-heading">
                <h1 class="page-title">{{$t('message.reporting')}}</h1>
            </div>
            <div class="page-heading">
                <div class="page-content fade-in-up">
                    
                     <div class="ibox">
                          <div class="ibox-body">
                              <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <div class="input-group-icon right">
                                                <div class="input-icon"><i class="fa fa-search"></i>
                                                </div>

                                                <input v-model="projectsFilter" @keyup="filterProjects"
                                                      class="form-control" type="text"
                                                      :placeholder="$t('message.filterProjects')">
                                            </div>
                                        </div>
                                        <div class="list-project-wrapper">
                                            <table class="table table-stripped" style="width: 170px">
                                                <tbody style="font-size: 0.9em">
                                                
                                                <tr style="cursor: pointer;"
                                                    v-for="(project, index) in projectsFiltered" :key="index">
                                                    <td :class="{activeProject: currentProjectIndex === index}" @click="setCurrentIndex(index)">{{project.name}}</td>
                                                    <td ><span v-if="project.status">{{$t('message.active')}} <button
                                                            style="height: 12px; width: 12px"
                                                            class="btn btn-sm btn-success btn-circle activity-button"></button></span><span
                                                            v-if="!project.status">{{$t('message.notActive')}} <button
                                                            style="height: 12px; width: 12px"
                                                            class="btn btn-sm btn-danger btn-circle activity-button"></button></span>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                               
                                  <div class="col-md-10" >
                                      <div style="display: flex">
                                          <div class="col-md-4">
                                            <label style="height: 35px" for="">{{$t('message.staticBudget')}}</label>
                                            <hr>
                                              <doughnut-chart :options="doughnutOptions" :chartData="doughnutDataStatic" class="doughnut"></doughnut-chart>  
                                         </div>
                                          
                                           <div class="col-md-4">
                                            <label style="height: 35px" for="">{{$t('message.dynamicBudgetUpToCurrentMonth')}}</label>
                                            <hr>
                                              <doughnut-chart :options="doughnutOptions" :chartData="doughnutDataBudget" class="doughnut"></doughnut-chart>  
                                          </div>
                                          
                                         <div class="col-md-4">
                                           <label style="height: 35px" for="">{{$t('message.actualCostsUpToCurrentMonth')}}</label>
                                           <hr>
                                            <doughnut-chart :options="doughnutOptions" :chartData="doughnutDataActual" class="doughnut"></doughnut-chart> 
                                        </div>  
                                     </div>
                                  </div>    
                              </div>

                              <div class="row" style="margin-top:30px">
                               
                                <div class="col-md-1"></div>
                                <div class="col-md-10" >
                                        <div style="float:left;">
                                          <label for="">{{$t('message.dataTable')}}</label>
                                          <input v-model="craftsmenFilter" @keyup="filterCraftsmen"
                                                      class="form-control" type="text"
                                                      style="width: 300px"
                                                      :placeholder="$t('message.filterCraftsmen')">
                                           <hr>
                                          <table class="table-hover table-bordered" style="margin-right: 10px; border-radius: 5px" v-if="tableData.length !== 0">
                                            <thead>
                                              <th>{{this.$t('message.companyName')}}</th>
                                              <th>{{this.$t('message.work')}}</th>
                                              <th style="background: #f2d00e; color:white">{{this.$t('message.dynamicBudget')}}</th>
                                              <th style="background: #f2d00e; color:white">{{this.$t('message.rollingForecast')}}</th>
                                              <th style="background: #f2d00e; color:white">{{this.$t('message.deviation')}}</th>
                                              <th style="background: #6DCEFD; color:white">{{$t('message.dynamicBudgetUpToCurrentMonth')}}</th>
                                              <th style="background: #6DCEFD; color:white">{{$t('message.actualCostsUpToCurrentMonth')}}</th>
                                              <th style="background: #6DCEFD; color:white">{{this.$t('message.deviation')}}</th>
                                            </thead> 
                                                    <tbody>
                                                          <tr style="background: #E5E5E5;">
                                                            <td style="text-align:right;"> <button class="btn view sortButton" @click="sortCraftsmen(0, 'company_name')"><i class="fa" v-bind:class="[arrayOfArrows[0].is_down ? 'fa-sort-asc' : 'fa-sort-desc']"></i></button></td>
                                                            <td style="text-align:right;"> <button class="btn view sortButton"  @click="sortCraftsmen(1, 'job')"><i class="fa" v-bind:class="[arrayOfArrows[1].is_down ? 'fa-sort-asc' : 'fa-sort-desc' ]"></i></button></td>
                                                            <td style="text-align:right;"> <button class="btn view sortButton"  @click="sortCraftsmen(2, 'dynamic_budget')"><i class="fa" v-bind:class="[arrayOfArrows[2].is_down ? 'fa-sort-asc' : 'fa-sort-desc']"></i></button></td>
                                                            <td style="text-align:right;"> <button class="btn view sortButton"  @click="sortCraftsmen(3, 'rolling_forecast')"><i class="fa" v-bind:class="[arrayOfArrows[3].is_down ? 'fa-sort-asc' : 'fa-sort-desc' ]"></i></button></td>
                                                            <td style="text-align:right;"> <button class="btn view sortButton"  @click="sortCraftsmen(4, 'deviation_dynamic_rolling')"><i class="fa" v-bind:class="[arrayOfArrows[4].is_down ? 'fa-sort-asc' : 'fa-sort-desc']"></i></button></td>
                                                            <td style="text-align:right;"> <button class="btn view sortButton"  @click="sortCraftsmen(5, 'budget_before')"><i class="fa" v-bind:class="[arrayOfArrows[5].is_down ? 'fa-sort-asc' : 'fa-sort-desc']"></i></button></td>
                                                            <td style="text-align:right;"> <button class="btn view sortButton"  @click="sortCraftsmen(6, 'actual_before')"><i class="fa" v-bind:class="[arrayOfArrows[6].is_down? 'fa-sort-asc' : 'fa-sort-desc']"></i></button></td>
                                                            <td style="text-align:right;"> <button class="btn view sortButton"  @click="sortCraftsmen(7, 'deviation_dynamic_actual')"><i class="fa" v-bind:class="[arrayOfArrows[7].is_down ? 'fa-sort-asc' : 'fa-sort-desc']"></i></button></td>
                                                          </tr>
                                                        <tr v-for="(data, index) in tableDataFiltered" :key="index">
                                                            <td scope="col">{{data.company_name}}</td>
                                                            <td scope="col">{{data.job}}</td>
                                                            <td scope="col" style="text-align:right">{{format(data.dynamic_budget)}}</td>
                                                            <td scope="col" style="text-align:right">{{format(data.rolling_forecast)}}</td>
                                                            <td scope="col" style="text-align:right; background:#DBD7D7">{{data.deviation_dynamic_rolling}}</td>
                                                            <td scope="col" style="text-align:right">{{format(data.budget_before)}}</td>
                                                            <td scope="col" style="text-align:right">{{format(data.actual_before)}}</td>
                                                            <td scope="col" style="text-align:right; background:#DBD7D7">{{data.deviation_dynamic_actual}}</td>
                                                        </tr>             
                                                  </tbody>
                                          </table>
                                        </div>
                                  </div>                                    

                              </div>
                              
                          </div>
                      </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import OkModal       from '../../modals/OkModal'
  import DoughnutChart from '../../charts/DoughnutChart' 

  export default {
  
    props: ['projectId'],
    name: 'SuperUserDashboard',
    components:{
       DoughnutChart
    },
    data () {
      return {
        isArrowCompanyNameDown: false,
        craftsmenFilter: null,
        arrayOfArrows:[
           {is_down: false},
           {is_down: false},
           {is_down: false},
           {is_down: false},
           {is_down: false},
           {is_down: false},
           {is_down: false},
           {is_down: false}
        ],
        doughnutDataStatic: {},
        doughnutDataActual: {},
        doughnutDataBudget: {},
        tableData: {},
        tableDataFiltered: {},
        doughnutOptions: {
          tooltips: {
                      callbacks: {
                        label: (tooltipItem, data) => {
                                    return this.formatToolTipsDoughnutCharts(tooltipItem, data)
                              }
                      }
                    },
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        },
        projects: [],
        propsArray: [],
        projectsFiltered: [],
        projectsFilter: '',
        consolidationData: {},
        currentProject: {},
        currentProjectIndex: -1,
      }
    },
    created () {
      this.getList(this.apiPrefix, this.projectApiUrl)
        .then(resp => {
          this.projects = resp.data
          this.projectsFiltered = this.projects
          
          if (this.projects.length) {
            if (!this.projectId) {
              this.getReportingData(this.projects[0].id)
              this.currentProjectIndex = 0;
            } else {
              const index = this.findByProperty(this.projects, 'id', this.projectId)
              this.getReportingData(this.projects[index].id);
              this.currentProjectIndex = index;
            }
          }
        })
        .catch(err => {
          console.log(err.response)
          this.$modal.show(OkModal, {
                    text: this.$t('message.oopsSomethingWentWrong'),
                    modalClass: this.modalClasses.okErrorClass
                  },
                  {
                    width: this.modalWidth(),
                    height: 'auto'
                  })

        })
    },
    methods: {
        formatToolTipsDoughnutCharts(tooltipItem, data){
            let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            let label = data.labels[tooltipItem.index]

            if (value !== null)
              return `${label}, CHF ${value.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "`")}`;
            return 'CHF 0'
        },
        sortCraftsmen(i, criteria){
             this.arrayOfArrows[i].is_down = !this.arrayOfArrows[i].is_down
            
             this.sortByCriteria(this.arrayOfArrows[i].is_down, criteria)
 
        },
         sortByCriteria(upOrDown, criteria){
           // some sorts are performed alphabetically, some by number, based on criteria
           if(criteria === 'company_name' || criteria === 'job')
             this.sort_alphabetically(upOrDown, criteria)
           else
             this.sort_by_number(upOrDown, criteria)
        },
        sort_by_number(upOrDown, criteria){
             if(upOrDown) 
               this.tableDataFiltered.sort(function(a, b){return a[criteria]-b[criteria];})
             else
               this.tableDataFiltered.sort(function(a, b){return b[criteria]-a[criteria];}) 
        },
        sort_alphabetically(upOrDown, criteria){
            if(upOrDown)
               this.tableDataFiltered.sort((a, b) => (a[criteria].toUpperCase() > b[criteria].toUpperCase()) ? 1 : -1)
             else  
               this.tableDataFiltered.sort((a, b) => (b[criteria].toUpperCase() > a[criteria].toUpperCase()) ? 1 : -1)
        },
        filterCraftsmen(){
             let filter = this.craftsmenFilter.toLowerCase()
          
             this.tableDataFiltered = this.tableData.filter( data => data.company_name.toLowerCase().includes(filter))
        },
        getReportingData(id){
           this.get(this.apiPrefix, this.projectApiUrl + 'get-reporting-data/', '', id)
          .then(resp => {
                  this.formatTableData(resp.data.table)
                  this.formatDoughnutData(1, resp.data.static)
                  this.formatDoughnutData(2, resp.data.actual)
                  this.formatDoughnutData(3, resp.data.budget)
               }).catch( () => {
        
                this.$modal.show(OkModal, {
                          text: this.$t('message.oopsSomethingWentWrong'),
                          modalClass: this.modalClasses.okErrorClass
                        },
                        {
                          width: this.modalWidth(),
                          height: 'auto'
                        })
          })       
        },
        formatTableData(data){
          
           for(let i=0; i<data.length; i++){
             data[i].deviation_dynamic_rolling = (data[i].rolling_forecast / (data[i].budget_before + data[i].budget_after)).toFixed(2)
             if(data[i].budget_before + data[i].budget_after === 0)
                 data[i].deviation_dynamic_rolling = 'n/a' 

             data[i].deviation_dynamic_actual = (data[i].actual_before / data[i].budget_before ).toFixed(2)
             if(data[i].budget_before === 0)
                 data[i].deviation_dynamic_actual = 'n/a'   

             data[i].dynamic_budget = data[i].budget_before + data[i].budget_after
           } 
          
           this.tableData = data
           this.tableDataFiltered = this.tableData
        },
        formatDoughnutData(doughnut, dataArray){
              
         if(dataArray.length > 4){
           dataArray = this.reduceListToFour(dataArray)
         }

         let labels = this.formatDataOrLabel(dataArray, 'company_name')
         let colors = this.formatColors(dataArray.length)
         let data = this.formatDataOrLabel(dataArray, 'amount')
         
          
          if(doughnut === 1){
               this.doughnutDataStatic = { labels: labels,
                 datasets: [{
                    borderWidth: 1,
                    borderColor: colors,
                    backgroundColor: colors,
                    data: data
               }]
             }
          }else if (doughnut === 2){
               this.doughnutDataActual = { labels: labels,
                 datasets: [{
                    borderWidth: 1,
                    borderColor: colors,
                    backgroundColor: colors,
                    data: data
                  }]
                }
          }else{
               this.doughnutDataBudget = { labels: labels,
                 datasets: [{
                    borderWidth: 1,
                    borderColor: colors,
                    backgroundColor: colors,
                    data: data
                  }]
                }
          }
          
        },
        formatColors(length){
           let colors = []
           //console.log(length)    

           for (let i=0; i<length; i++){
             let first = Math.floor(Math.random() * 256);
             let second = Math.floor(Math.random() * 256);
             let third = Math.floor(Math.random() * 256);
             let color = `rgba(${first}, ${second}, ${third}, 0.5)`
             colors.push(color)
           }

           return colors
        },

        // reduce the list of companies to 4 and add the `rest` element
        reduceListToFour(array){
            let sumOveral = 0
            let sumReduced = 0
            let sumRest = 0

            for(let i=0; i<array.length; i++){
              sumOveral += array[i]['amount']
            } 

            array.sort(function(a, b){
                return b.amount - a.amount 
            })

            array = array.slice(0, 4)

            for(let i=0; i<array.length; i++){
              sumReduced += array[i]['amount']
            } 

            sumRest = sumOveral - sumReduced

            array.push({
              company_name: this.$t('message.rest'),
              amount: sumRest
            })

            return array;
        },
      filterProjects () {
        let filter = this.projectsFilter.toLowerCase()

        this.projectsFiltered = this.projects.filter(project => {
          if (filter === '') {
            return true
          }

          return project.name.toLowerCase().startsWith(filter)
        })
      },
      setCurrentIndex(index) {
        this.currentProjectIndex = index;

        this.getReportingData(this.projects[this.currentProjectIndex].id)
      }
    }
  }
</script>

<style scoped>
    td, th {
        padding: 3px 9px;
    }

    .list-project-wrapper {
        max-height: 850px;
        overflow-y: auto;
    }

    .activeProject{
        color: #0b93d5;
    }

    .doughnut {
      height: 300px;
      
    }

    .chart-box-wrapper {
        color: grey;
        margin: 2%;
        border: 1px solid rgba(220, 220, 220, 0.6);
        border-radius: 4px;
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12);
        min-height: 188px;
        padding: 9px;
    }

    .chart-box-wrapper:hover {
        background-color: rgba(220, 220, 220, 0.3);
    }

    th, td{
      margin-right: 2px;
     }

     .sortButton{
       height: 27px; 
       width: 30px
     }
</style>